function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("jNgkC", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$dbd84b38d35c95a3$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "PANEL_ID", ()=>(parcelRequire("fvFzs")).PANEL_ID);
    $parcel$export(module.exports, "SIDEBAR_WIDTH", ()=>(parcelRequire("fvFzs")).SIDEBAR_WIDTH);
    $parcel$export(module.exports, "useSetProjectListRightPanelState", ()=>(parcelRequire("9ZLvc")).useSetProjectListRightPanelState);
    var $aHZzf = parcelRequire("aHZzf");
    var $eUqFw = parcelRequire("eUqFw");
    var $iWLL0 = parcelRequire("iWLL0");
    var $0cdA8 = parcelRequire("0cdA8");
    var $bUi2Q = parcelRequire("bUi2Q");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $fvFzs = parcelRequire("fvFzs");
    var $d2K0B = parcelRequire("d2K0B");
    var $9ZLvc = parcelRequire("9ZLvc");
    const $dbd84b38d35c95a3$var$JiraProjectsTemplateListRightPanel = ({ queries: { templatesQueryRef: templatesQueryRef } })=>{
        const { openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
        const rootQueryRef = (0, $iWLL0.usePreloadedQuery)((0, $aHZzf.default), templatesQueryRef);
        const { jira: jira } = rootQueryRef;
        const isAnonymous = templatesQueryRef?.variables.isAnonymous;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        (0, $eUqFw.useEffect)(()=>{
            if (isAnonymous) return;
            if (!(typeof jira?.sidebarExperimentTemplates?.totalCount === 'number') || !(jira?.sidebarExperimentTemplates.totalCount > 0) || !jira?.userPreferences?.projectListRightPanelState || !jira?.canCreateProject) {
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebarEligibility failed');
                return;
            }
            if (jira?.userPreferences.projectListRightPanelState === 'OPEN') openRightSidebar((0, $fvFzs.PANEL_ID), (0, $fvFzs.SIDEBAR_WIDTH), false, true);
            if (jira?.userPreferences.projectListRightPanelState === 'CLOSED') closeRightSidebar((0, $fvFzs.PANEL_ID));
        }, [
            openRightSidebar,
            closeRightSidebar,
            createAnalyticsEvent,
            isAnonymous,
            jira?.sidebarExperimentTemplates?.totalCount,
            jira?.userPreferences?.projectListRightPanelState,
            jira?.canCreateProject
        ]);
        const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
        const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
        const prevPanelIdRef = (0, $eUqFw.useRef)();
        const delayRef = (0, $eUqFw.useRef)(undefined);
        const panelId = rightSidebarCurrentState?.panelId;
        (0, $eUqFw.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, $fvFzs.PANEL_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        (0, $eUqFw.useEffect)(()=>()=>{
                closeRightSidebar((0, $fvFzs.PANEL_ID));
            }, [
            closeRightSidebar
        ]);
        if (localPanelId !== (0, $fvFzs.PANEL_ID)) return null;
        if (isAnonymous) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $d2K0B.default), {
            dataRef: rootQueryRef
        });
    };
    const $dbd84b38d35c95a3$var$JiraProjectsTemplateListRightPanelContainer = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-layout-component",
            packageName: "jiraGrowthRecommendationsInProjectList"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($dbd84b38d35c95a3$var$JiraProjectsTemplateListRightPanel, props));
    var $dbd84b38d35c95a3$export$2e2bcd8739ae039 = $dbd84b38d35c95a3$var$JiraProjectsTemplateListRightPanelContainer;
});
parcelRegister("aHZzf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e18984271717fa50$export$2e2bcd8739ae039);
    var $cNy9K = parcelRequire("cNy9K");
    const $e18984271717fa50$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isAnonymous"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = [
            v1
        ], v3 = [
            v1,
            {
                "kind": "Literal",
                "name": "experimentKey",
                "value": "sidebarExperiment"
            }
        ], v4 = {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": v2,
                    "concreteType": "JiraUserPreferences",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "projectListRightPanelState"
                        }
                    ]
                },
                {
                    "alias": "sidebarExperimentTemplates",
                    "args": v3,
                    "concreteType": "JiraProjectListViewTemplateConnection",
                    "kind": "LinkedField",
                    "name": "projectListViewTemplates",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                },
                {
                    "alias": "canCreateProject",
                    "args": [
                        v1,
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "CREATE_PROJECT"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
                "selections": [
                    {
                        "condition": "isAnonymous",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v4,
                                "action": "THROW",
                                "path": "jira"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "container_growthRecommendationsInProjectList_RecommendationsInProjectList"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
                "selections": [
                    {
                        "condition": "isAnonymous",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            v4
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraProjectListViewTemplateConnection",
                                "kind": "LinkedField",
                                "name": "projectListViewTemplates",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectListViewTemplateItem",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "templateType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "productKey"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isProductLicensed"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "title"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "shortDescription"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isPremiumOnly"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "recommendationSessionId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "iconDarkUrl"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "previewUrl"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "previewDarkUrl"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v2,
                                "concreteType": "JiraUserPreferences",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "f31dd28adcaf6c18a0dc9713c957a224b1432a8978a87fc1069abdd23c838a83",
                "metadata": {},
                "name": "ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e18984271717fa50$var$node.hash = "fc55adfe7ee5532c212fa2d7dc482641";
    (0, $cNy9K.PreloadableQueryRegistry).set($e18984271717fa50$var$node.params.id, $e18984271717fa50$var$node);
    var $e18984271717fa50$export$2e2bcd8739ae039 = $e18984271717fa50$var$node;
});
parcelRegister("d2K0B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$587827e5ae6da5f8$export$2e2bcd8739ae039);
    var $jLbLi = parcelRequire("jLbLi");
    var $eUqFw = parcelRequire("eUqFw");
    var $iWLL0 = parcelRequire("iWLL0");
    var $lNqwd = parcelRequire("lNqwd");
    var $ld5Wr = parcelRequire("ld5Wr");
    var $lKozG = parcelRequire("lKozG");
    var $amx2g = parcelRequire("amx2g");
    var $3zwh8 = parcelRequire("3zwh8");
    var $23sYR = parcelRequire("23sYR");
    var $jGR8u = parcelRequire("jGR8u");
    var $1AHzd = parcelRequire("1AHzd");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    var $0cdA8 = parcelRequire("0cdA8");
    var $79xbN = parcelRequire("79xbN");
    var $eI5EY = parcelRequire("eI5EY");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $8WuJm = parcelRequire("8WuJm");
    var $d6f6c = parcelRequire("d6f6c");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $lbttE = parcelRequire("lbttE");
    var $3e9vj = parcelRequire("3e9vj");
    var $6Nlij = parcelRequire("6Nlij");
    var $fvFzs = parcelRequire("fvFzs");
    var $94IV8 = parcelRequire("94IV8");
    var $9ZLvc = parcelRequire("9ZLvc");
    var $umY9P = parcelRequire("umY9P");
    var $fvI0s = parcelRequire("fvI0s");
    var $3TS41 = parcelRequire("3TS41");
    const $587827e5ae6da5f8$var$RecommendationsInProjectList = ({ dataRef: dataRef })=>{
        const [templatePreviewKey, setTemplatePreviewKey] = (0, $eUqFw.useState)(null);
        const environment = (0, $3e9vj.useEnvironment)();
        const { fireViewedUIEvent: fireViewedUIEvent } = (0, $6Nlij.useFireCrossFlowAnalyticsEvents)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const { methods: { open: openProjectCreate } } = (0, $lbttE.useProjectCreateDrawer)();
        const buttonEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const { jira: jira } = (0, $iWLL0.useFragment)((0, $jLbLi.default), dataRef);
        const setProjectListRightPanelState = (0, $9ZLvc.useSetProjectListRightPanelState)(jira?.userPreferences?.__id);
        const onCloseClick = (0, $eUqFw.useCallback)(()=>{
            (0, $jMP2a.fireUIAnalytics)(buttonEvent, 'closeButton');
            setProjectListRightPanelState('CLOSED');
        }, [
            buttonEvent,
            setProjectListRightPanelState
        ]);
        const templates = (0, $eUqFw.useMemo)(()=>jira.projectListViewTemplates?.nodes?.filter((template)=>!!template) ?? [], [
            jira.projectListViewTemplates?.nodes
        ]);
        const templatePreviewRef = (0, $eUqFw.useMemo)(()=>templates.find((template)=>template.key === templatePreviewKey), [
            templatePreviewKey,
            templates
        ]);
        const recommendedProductIds = (0, $eUqFw.useMemo)(()=>Array.from(templates.reduce((acc, template)=>{
                const { isProductLicensed: isProductLicensed, productKey: productKey } = template;
                if (!isProductLicensed) acc.add((0, $fvFzs.getProductTypeCcpReferenceIdMapForEnv)(environment)[productKey]);
                return acc;
            }, new Set())), [
            environment,
            templates
        ]);
        const onMoreTemplatesClick = (0, $eUqFw.useCallback)(()=>{
            (0, $jMP2a.fireUIAnalytics)(buttonEvent, 'moreTemplatesButton');
            openProjectCreate({
                showExperienceSelection: false,
                source: (0, $fvFzs.PROJECT_CREATE_SOURCE)
            });
        }, [
            buttonEvent,
            openProjectCreate
        ]);
        (0, $eUqFw.useEffect)(()=>{
            recommendedProductIds.length > 0 && fireViewedUIEvent({
                action: 'viewed',
                actionSubject: 'section',
                actionSubjectId: 'projectsDirectorySidebar'
            }, {
                recommendedProductIds: recommendedProductIds,
                source: 'projectsDirectorySidebarSection'
            });
        }, [
            fireViewedUIEvent,
            recommendedProductIds
        ]);
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('cb_jira_template_recs_with_for_all_products');
        const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            id: "jira-project-list-side-panel",
            xcss: $587827e5ae6da5f8$var$SidebarContainerStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            xcss: $587827e5ae6da5f8$var$ExperimentSidebarContentStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1AHzd.default), {
            xcss: $587827e5ae6da5f8$var$TitleStyles,
            alignBlock: "center",
            spread: "space-between"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ld5Wr.default), {
            level: "h100"
        }, formatMessage((0, $94IV8.messages).title)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $587827e5ae6da5f8$var$ButtonBoxStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lNqwd.default), {
            iconBefore: (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($lKozG))), {
                label: ""
            }),
            "aria-label": formatMessage((0, $94IV8.messages).closeButton),
            appearance: "subtle",
            onClick: onCloseClick
        }))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            as: "p",
            xcss: $587827e5ae6da5f8$var$SubtitleStyles
        }, formatMessage((0, $94IV8.messages).subtitle))), templates.map((cardRef)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $umY9P.TemplateCard), {
                key: cardRef.key,
                dataRef: cardRef,
                recommendedProductIds: recommendedProductIds,
                setTemplatePreviewKey: setTemplatePreviewKey
            })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1AHzd.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lNqwd.default), {
            appearance: "link",
            spacing: "none",
            label: formatMessage((0, $94IV8.messages).moreTemplatesLink),
            onClick: ()=>onMoreTemplatesClick()
        }, (0, $94IV8.messages).moreTemplatesLink && formatMessage((0, $94IV8.messages).moreTemplatesLink)))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                templates: templates.map(({ key: key })=>key),
                templateTypes: shouldUseNewRecommendations ? templates.map(({ templateType: templateType })=>templateType) : undefined
            }
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3TS41.JiraProjectListSidePanelSkipLink), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "template-preview-wrapper",
            packageName: "jiraGrowthRecommendationsInProjectList"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $amx2g.default), null, templatePreviewRef && ((0, $eI5EY.fg)('templates_sidebar_preview_in_popup') ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $23sYR.default), {
            isOpen: true,
            placement: "left",
            offset: [
                0,
                0
            ],
            autoFocus: false,
            trigger: (triggureProps)=>(0, ($parcel$interopDefault($eUqFw))).createElement("div", triggureProps),
            content: ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $3zwh8.default), {
                    duration: 500
                }, (fadeInProps)=>(0, ($parcel$interopDefault($eUqFw))).createElement("div", fadeInProps, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fvI0s.TemplatePreview), {
                        previewRef: templatePreviewRef
                    })))
        }) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3zwh8.default), {
            duration: 500
        }, (fadeInProps)=>(0, ($parcel$interopDefault($eUqFw))).createElement("div", fadeInProps, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fvI0s.TemplatePreview), {
                previewRef: templatePreviewRef
            })))))));
    };
    const $587827e5ae6da5f8$var$RecommendationsInProjectListContainer = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "projectListTemplates",
            sourceType: (0, $41ea3621645e2acc$export$9d2de6eebf7462b5)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($587827e5ae6da5f8$var$RecommendationsInProjectList, props));
    const $587827e5ae6da5f8$var$TitleStyles = (0, $fHiYa.xcss)({
        textTransform: 'uppercase',
        color: 'color.text.subtle',
        position: 'relative'
    });
    const $587827e5ae6da5f8$var$ButtonBoxStyles = (0, $fHiYa.xcss)({
        paddingInline: 'space.050'
    });
    const $587827e5ae6da5f8$var$SubtitleStyles = (0, $fHiYa.xcss)({
        color: 'color.text.subtlest',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        marginTop: 'space.0'
    });
    const $587827e5ae6da5f8$var$ExperimentSidebarContentStyles = (0, $fHiYa.xcss)({
        height: '100%',
        overflow: 'auto',
        width: '360px',
        padding: 'space.300',
        backgroundColor: 'elevation.surface.sunken',
        boxSizing: 'border-box'
    });
    const $587827e5ae6da5f8$var$SidebarContainerStyles = (0, $fHiYa.xcss)({
        height: `calc(100vh - ${(0, $hwyJ1.UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT)} - ${(0, $hwyJ1.UNSAFE_DO_NOT_USE_BANNER_HEIGHT)})`
    });
    var $587827e5ae6da5f8$export$2e2bcd8739ae039 = $587827e5ae6da5f8$var$RecommendationsInProjectListContainer;
});
parcelRegister("jLbLi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$138395892c41170e$export$2e2bcd8739ae039);
    const $138395892c41170e$var$node = function() {
        var v0 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        };
        return {
            "argumentDefinitions": [
                {
                    "kind": "RootArgument",
                    "name": "cloudId"
                }
            ],
            "kind": "Fragment",
            "name": "container_growthRecommendationsInProjectList_RecommendationsInProjectList",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    v0,
                                    {
                                        "kind": "Literal",
                                        "name": "experimentKey",
                                        "value": "sidebarExperiment"
                                    }
                                ],
                                "concreteType": "JiraProjectListViewTemplateConnection",
                                "kind": "LinkedField",
                                "name": "projectListViewTemplates",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectListViewTemplateItem",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                "action": "THROW",
                                                "path": "jira.projectListViewTemplates.nodes.key"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "templateType"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "productKey"
                                                },
                                                "action": "THROW",
                                                "path": "jira.projectListViewTemplates.nodes.productKey"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "isProductLicensed"
                                                },
                                                "action": "THROW",
                                                "path": "jira.projectListViewTemplates.nodes.isProductLicensed"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "card_growthRecommendationsInProjectList_TemplateCard"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "preview_growthRecommendationsInProjectList_TemplatePreview"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v0
                                ],
                                "concreteType": "JiraUserPreferences",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        };
    }();
    $138395892c41170e$var$node.hash = "ed7a729d18ae30ff07077f4116523d01";
    var $138395892c41170e$export$2e2bcd8739ae039 = $138395892c41170e$var$node;
});
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("94IV8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2cfd3885263b16d9$export$defe85febe8b728c);
    var $90IgZ = parcelRequire("90IgZ");
    const $2cfd3885263b16d9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
        title: {
            "id": "growth-recommendations-in-project-list.title",
            "defaultMessage": "Templates"
        },
        subtitle: {
            "id": "growth-recommendations-in-project-list.subtitle",
            "defaultMessage": "Preview a template for your next project"
        },
        moreTemplatesLink: {
            "id": "growth-recommendations-in-project-list.more-templates-link",
            "defaultMessage": "More templates"
        },
        closeButton: {
            "id": "growth-recommendations-in-project-list.close-button",
            "defaultMessage": "Close"
        },
        tryLozenge: {
            "id": "growth-recommendations-in-project-list.try-lozenge",
            "defaultMessage": "Try"
        },
        premiumLozenge: {
            "id": "growth-recommendations-in-project-list.premium-lozenge",
            "defaultMessage": "Premium"
        },
        productKeyBusinessLabelSpork: {
            "id": "growth-recommendations-in-project-list.product-key-business-label-spork",
            "defaultMessage": "Get Jira to use this template"
        },
        productKeySoftwareLabelSpork: {
            "id": "growth-recommendations-in-project-list.product-key-software-label-spork",
            "defaultMessage": "Get Jira to use this template"
        },
        productKeyServiceDeskLabel: {
            "id": "growth-recommendations-in-project-list.product-key-service-desk-label",
            "defaultMessage": "Get Jira Service Management to use this template"
        },
        productKeyProductDiscoveryLabel: {
            "id": "growth-recommendations-in-project-list.product-key-product-discovery-label",
            "defaultMessage": "Get Jira Product Discovery to use this template"
        },
        premiumTemplateDiscoveryLabelSpork: {
            "id": "growth-recommendations-in-project-list.premium-template-discovery-label-spork",
            "defaultMessage": "Upgrade to Jira Premium to use this template"
        }
    });
});
parcelRegister("9ZLvc", function(module, exports) {
    $parcel$export(module.exports, "useSetProjectListRightPanelState", ()=>$45e01b16e8e32362$export$f7872413c3847449);
    var $3agfp = parcelRequire("3agfp");
    var $eUqFw = parcelRequire("eUqFw");
    var $iWLL0 = parcelRequire("iWLL0");
    var $guiFP = parcelRequire("guiFP");
    var $dWLk9 = parcelRequire("dWLk9");
    const $45e01b16e8e32362$var$PROJECT_LIST_RIGHT_PANEL_STATE = 'projectListRightPanelState';
    const $45e01b16e8e32362$var$relayStoreUpdater = (store, userPreferencesRefId, state)=>{
        if (typeof userPreferencesRefId === 'string') {
            const record = store.get(userPreferencesRefId);
            record?.setValue(state, $45e01b16e8e32362$var$PROJECT_LIST_RIGHT_PANEL_STATE);
        }
    };
    const $45e01b16e8e32362$export$f7872413c3847449 = (userPreferencesRefId)=>{
        const cloudId = (0, $dWLk9.useCloudId)();
        const [commit] = (0, $iWLL0.useMutation)((0, $3agfp.default));
        const setRightPanelState = (0, $eUqFw.useCallback)((state)=>{
            commit({
                variables: {
                    cloudId: cloudId,
                    state: state
                },
                optimisticUpdater: (store)=>$45e01b16e8e32362$var$relayStoreUpdater(store, userPreferencesRefId, state),
                updater: (store, { jira: { userPreferences: { setProjectListRightPanelState: { projectListRightPanelState: projectListRightPanelState } } } })=>$45e01b16e8e32362$var$relayStoreUpdater(store, userPreferencesRefId, projectListRightPanelState ?? state),
                onCompleted: ({ jira: { userPreferences: { setProjectListRightPanelState: { success: success, errors: errors } } } })=>{
                    const error = (errors ?? [])[0];
                    if (!success || error) {
                        const errorMessage = `error on set project list right panel state: ${error.message}`;
                        const statusCode = error.extensions?.statusCode;
                        (0, $guiFP.default)({
                            error: new Error(`status code: ${statusCode ?? 'unknown'}, ${errorMessage}`),
                            meta: {
                                id: 'jiraSetProjectListRightPanelStateError',
                                packageName: 'jiraGrowthRecommendationsInProjectList'
                            }
                        });
                    }
                },
                onError: (error)=>{
                    (0, $guiFP.default)({
                        error: new Error(`jiraSetProjectListRightPanelStateMutationError with ${error.message}`),
                        meta: {
                            id: 'jiraSetProjectListRightPanelStateMutationError',
                            packageName: 'jiraGrowthRecommendationsInProjectList'
                        }
                    });
                }
            });
        }, [
            cloudId,
            commit,
            userPreferencesRefId
        ]);
        return setRightPanelState;
    };
});
parcelRegister("3agfp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed9c7ca4637149ec$export$2e2bcd8739ae039);
    const $ed9c7ca4637149ec$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "state"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = [
            {
                "kind": "Variable",
                "name": "state",
                "variableName": "state"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "success"
        }, v4 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v5 = {
            "kind": "ScalarField",
            "name": "message"
        }, v6 = {
            "kind": "ScalarField",
            "name": "projectListRightPanelState"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUserPreferencesMutation",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2,
                                        "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                        "kind": "LinkedField",
                                        "name": "setProjectListRightPanelState",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "concreteType": "MutationError",
                                                "kind": "LinkedField",
                                                "name": "errors",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "extensions",
                                                        "plural": false,
                                                        "selections": [
                                                            v4
                                                        ]
                                                    },
                                                    v5
                                                ]
                                            },
                                            v6
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraUserPreferencesMutation",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v2,
                                        "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                        "kind": "LinkedField",
                                        "name": "setProjectListRightPanelState",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "concreteType": "MutationError",
                                                "kind": "LinkedField",
                                                "name": "errors",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "extensions",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__typename"
                                                            },
                                                            v4,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "id"
                                                                    }
                                                                ],
                                                                "type": "BulkMutationErrorExtension"
                                                            }
                                                        ]
                                                    },
                                                    v5
                                                ]
                                            },
                                            v6
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "c9fc45f1ccb390d27ba078874be435f11bb5799b236a50a6fc32b19b5b705f8b",
                "metadata": {},
                "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $ed9c7ca4637149ec$var$node.hash = "1cbcdd010c06eb6470327729729fba37";
    var $ed9c7ca4637149ec$export$2e2bcd8739ae039 = $ed9c7ca4637149ec$var$node;
});
parcelRegister("umY9P", function(module, exports) {
    $parcel$export(module.exports, "TemplateCard", ()=>$7e1ed1b44310958c$export$ba340e850b866867);
    var $iqojN = parcelRequire("iqojN");
    var $eUqFw = parcelRequire("eUqFw");
    var $bcR4J = parcelRequire("bcR4J");
    var $iWLL0 = parcelRequire("iWLL0");
    var $h7bgU = parcelRequire("h7bgU");
    var $jGR8u = parcelRequire("jGR8u");
    var $1AHzd = parcelRequire("1AHzd");
    var $23gMr = parcelRequire("23gMr");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    var $l3Qg0 = parcelRequire("l3Qg0");
    var $3q7Yq = parcelRequire("3q7Yq");
    var $6j4bv = parcelRequire("6j4bv");
    var $79xbN = parcelRequire("79xbN");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $lbttE = parcelRequire("lbttE");
    var $6KONZ = parcelRequire("6KONZ");
    var $3e9vj = parcelRequire("3e9vj");
    var $6Nlij = parcelRequire("6Nlij");
    var $fvFzs = parcelRequire("fvFzs");
    var $94IV8 = parcelRequire("94IV8");
    var $3w6SH = parcelRequire("3w6SH");
    var $i0qR9 = parcelRequire("i0qR9");
    var $7zLQ9 = parcelRequire("7zLQ9");
    const $7e1ed1b44310958c$export$ba340e850b866867 = ({ dataRef: dataRef, recommendedProductIds: recommendedProductIds, setTemplatePreviewKey: setTemplatePreviewKey })=>{
        const environment = (0, $3e9vj.useEnvironment)();
        const { fireInteractedUIEvent: fireInteractedUIEvent } = (0, $6Nlij.useFireCrossFlowAnalyticsEvents)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const crossFlow = (0, $bcR4J.useCrossFlow)();
        const { methods: { open: openProjectCreate } } = (0, $lbttE.useProjectCreateDrawer)();
        const cardEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'card'
        });
        const cardHoveredEvent = createAnalyticsEvent({
            action: 'hovered',
            actionSubject: 'card'
        });
        const template = (0, $iWLL0.useFragment)((0, $iqojN.default), dataRef);
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('cb_jira_template_recs_with_for_all_products');
        const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
        const { title: title, shortDescription: shortDescription, key: key, isProductLicensed: isProductLicensed, isPremiumOnly: isPremiumOnly, productKey: productKey, templateType: templateType, recommendationSessionId: recommendationSessionId } = template;
        const { shouldPromptJsmTrial: shouldPromptJsmTrial } = (0, $3w6SH.useShouldPromptJsmTrial)({
            templateKey: key
        });
        const [isJsmPremiumUpgradeModalOpen, setIsJsmPremiumUpgradeModalOpen] = (0, $eUqFw.useState)(false);
        const entryPoint = (0, $6j4bv.useEntryPoint)((0, $6KONZ.servicedeskStandardToPremiumModalEntryPoint), {});
        const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPoint.entryPointActions);
        const extensions = (0, $eUqFw.useMemo)(()=>(0, $7zLQ9.buildCrossflowExtensions)({
                templateId: shouldUseNewRecommendations ? templateType ?? key : key,
                recommendationSessionId: recommendationSessionId
            }), [
            key,
            recommendationSessionId,
            shouldUseNewRecommendations,
            templateType
        ]);
        const onClick = (0, $eUqFw.useCallback)(()=>{
            (0, $jMP2a.fireUIAnalytics)(cardEvent, 'templateCard', {
                key: key,
                productKey: productKey,
                isProductLicensed: isProductLicensed,
                isPremiumOnly: isPremiumOnly,
                ...shouldUseNewRecommendations ? {
                    templateType: templateType,
                    recommendationSessionId: recommendationSessionId
                } : {
                    extensions: extensions
                }
            });
            if (shouldPromptJsmTrial) {
                setIsJsmPremiumUpgradeModalOpen(true);
                return;
            }
            if (!isProductLicensed && crossFlow.isEnabled && (0, $fvFzs.PROJECT_TYPE_TARGETS_MAP)[productKey] && (0, $fvFzs.getProductTypeCcpReferenceIdMapForEnv)(environment)[productKey]) {
                fireInteractedUIEvent({
                    action: 'clicked',
                    actionSubject: 'card',
                    actionSubjectId: 'templateCard'
                }, {
                    recommendedProductIds: recommendedProductIds,
                    recommendationSession: {
                        id: recommendationSessionId,
                        type: 'appRec'
                    },
                    targetProductId: (0, $fvFzs.getProductTypeCcpReferenceIdMapForEnv)(environment)[productKey],
                    source: 'projectsDirectorySidebarSection'
                });
                crossFlow.api.open({
                    journey: (0, $bcR4J.Journeys).GET_STARTED,
                    targetProduct: (0, $fvFzs.PROJECT_TYPE_TARGETS_MAP)[productKey],
                    sourceComponent: 'projectsDirectorySidebarSection',
                    sourceContext: 'templateCard',
                    extensions: extensions
                });
                return;
            }
            openProjectCreate({
                selectedProjectType: productKey.toLowerCase(),
                showExperienceSelection: false,
                defaultSelectedTemplateKey: key,
                source: (0, $fvFzs.PROJECT_CREATE_SOURCE),
                ...shouldUseNewRecommendations && {
                    recommendationSessionId: recommendationSessionId
                }
            });
        }, [
            cardEvent,
            key,
            productKey,
            isProductLicensed,
            isPremiumOnly,
            shouldUseNewRecommendations,
            templateType,
            recommendationSessionId,
            extensions,
            crossFlow,
            environment,
            openProjectCreate,
            fireInteractedUIEvent,
            shouldPromptJsmTrial,
            recommendedProductIds
        ]);
        const onPreviewDismiss = ()=>{
            setTemplatePreviewKey((current)=>{
                if (current === key) return null;
                return current;
            });
        };
        const onPreviewStart = ()=>{
            (0, $jMP2a.fireUIAnalytics)(cardHoveredEvent, 'templateCard', {
                key: key,
                productKey: productKey,
                isProductLicensed: isProductLicensed,
                templateType: templateType,
                isPremiumOnly: isPremiumOnly
            });
            setTemplatePreviewKey(key);
        };
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            as: "span",
            xcss: $7e1ed1b44310958c$var$PaddedCardStyles,
            onMouseEnter: onPreviewStart,
            onMouseLeave: onPreviewDismiss
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $23gMr.default), {
            padding: "space.200",
            xcss: $7e1ed1b44310958c$var$CardStyles,
            onFocus: onPreviewStart,
            onBlur: onPreviewDismiss,
            onClick: onClick,
            tabIndex: 0,
            ...shouldPromptJsmTrial && {
                ref: triggerRef
            }
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1AHzd.default), {
            space: "space.150",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $i0qR9.default), {
            keyRef: template
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            as: "div",
            space: "space.050"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            as: "span",
            xcss: $7e1ed1b44310958c$var$TitleStyles
        }, title, ' ', !isProductLicensed && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h7bgU.default), {
            appearance: "new"
        }, formatMessage((0, $94IV8.messages).tryLozenge)), isProductLicensed && isPremiumOnly && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h7bgU.default), {
            appearance: "new"
        }, formatMessage((0, $94IV8.messages).premiumLozenge))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            as: "p",
            xcss: $7e1ed1b44310958c$var$DescriptionStyles
        }, shortDescription))))), isJsmPremiumUpgradeModalOpen && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
            entryPointReferenceSubject: entryPoint.entryPointReferenceSubject,
            id: "standard-to-premium-modal",
            packageName: "jira-cmdb-upsell-page",
            teamName: "ITOps Mithril",
            entryPointActions: entryPoint.entryPointActions,
            runtimeProps: {
                onClose: ()=>{
                    setIsJsmPremiumUpgradeModalOpen(false);
                },
                origin: 'templateCard'
            }
        }));
    };
    const $7e1ed1b44310958c$var$PaddedCardStyles = (0, $fHiYa.xcss)({
        backgroundColor: 'color.background.neutral.subtle',
        paddingBlock: 'space.100'
    });
    const $7e1ed1b44310958c$var$CardStyles = (0, $fHiYa.xcss)({
        width: '100%',
        textAlign: 'left',
        borderRadius: 'border.radius',
        boxShadow: 'elevation.shadow.raised',
        backgroundColor: 'elevation.surface.raised',
        ':hover': {
            background: 'elevation.surface.overlay',
            boxShadow: 'elevation.shadow.overlay'
        },
        ':focus': {
            background: 'elevation.surface.overlay',
            boxShadow: 'elevation.shadow.overlay'
        }
    });
    const $7e1ed1b44310958c$var$TitleStyles = (0, $fHiYa.xcss)({
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: 'color.text'
    });
    const $7e1ed1b44310958c$var$DescriptionStyles = (0, $fHiYa.xcss)({
        margin: '0',
        color: 'color.text.subtlest',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
});
parcelRegister("iqojN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e779abf3268ab1b3$export$2e2bcd8739ae039);
    const $e779abf3268ab1b3$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "card_growthRecommendationsInProjectList_TemplateCard",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "title"
                },
                "action": "THROW",
                "path": "title"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "shortDescription"
                },
                "action": "THROW",
                "path": "shortDescription"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "isProductLicensed"
                },
                "action": "THROW",
                "path": "isProductLicensed"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "isPremiumOnly"
                },
                "action": "THROW",
                "path": "isPremiumOnly"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "productKey"
                },
                "action": "THROW",
                "path": "productKey"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "recommendationSessionId"
                },
                "action": "THROW",
                "path": "recommendationSessionId"
            },
            {
                "kind": "ScalarField",
                "name": "templateType"
            },
            {
                "kind": "FragmentSpread",
                "name": "icon_growthRecommendationsInProjectList_CardIcon"
            }
        ],
        "type": "JiraProjectListViewTemplateItem"
    };
    $e779abf3268ab1b3$var$node.hash = "a3a64269e13340446cb811b0ad3c2748";
    var $e779abf3268ab1b3$export$2e2bcd8739ae039 = $e779abf3268ab1b3$var$node;
});
parcelRegister("l3Qg0", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointButtonTrigger", ()=>$c6e813dbc513f02a$export$25d2524a63315ed);
    $parcel$export(module.exports, "getDefaultEntrypointActionEventMap", ()=>$c6e813dbc513f02a$export$5f13515bd3a35325);
    var $eUqFw = parcelRequire("eUqFw");
    var $eI5EY = parcelRequire("eI5EY");
    var $a9frS = parcelRequire("a9frS");
    const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions), shouldFocusBackOnSecondMount = false)=>{
        const removePreviousListeners = (0, $eUqFw.useRef)(null);
        const isMounted = (0, $eUqFw.useRef)(true);
        const isNotFirstMount = (0, $eUqFw.useRef)(false);
        (0, $eUqFw.useEffect)(()=>()=>{
                removePreviousListeners.current?.();
                removePreviousListeners.current = null;
                isMounted.current = false;
            }, []);
        return (0, $eUqFw.useCallback)((element)=>{
            if (!isMounted.current) return;
            removePreviousListeners.current?.();
            if (element && isActive) {
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'add',
                    eventMap: eventMap
                });
                removePreviousListeners.current = ()=>{
                    (0, $a9frS.modifyListeners)({
                        element: element,
                        operationName: 'remove',
                        eventMap: eventMap
                    });
                };
                if (shouldFocusBackOnSecondMount && isNotFirstMount.current && (0, $eI5EY.fg)('jsc_create_bar_refresh')) element.focus();
            } else {
                removePreviousListeners.current = null;
                isNotFirstMount.current = true;
            }
        }, [
            eventMap,
            isActive,
            shouldFocusBackOnSecondMount
        ]);
    };
    const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
            click: actions.load,
            mouseenter: actions.preload,
            mouseleave: actions.cancelPreload,
            focusin: actions.preload,
            focusout: actions.cancelPreload
        });
});
parcelRegister("a9frS", function(module, exports) {
    $parcel$export(module.exports, "modifyListeners", ()=>$592b51d0c18fde03$export$15257a36a7e3f9d6);
    function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
        const { element: element, operationName: operationName, eventMap: eventMap } = params;
        const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
        if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
    }
});
parcelRegister("3q7Yq", function(module, exports) {
    $parcel$export(module.exports, "ModalEntryPointContainer", ()=>$79aee538140aeba6$export$4d67c6ee49f3d14d);
    var $eUqFw = parcelRequire("eUqFw");
    var $eUJtf = parcelRequire("eUJtf");
    var $P6D7Q = parcelRequire("P6D7Q");
    var $ioLN0 = parcelRequire("ioLN0");
    const $79aee538140aeba6$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
        const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
        const props = (0, $eUqFw.useMemo)(()=>({
                ...runtimeProps,
                onClose () {
                    runtimeProps.onClose?.();
                    unload();
                }
            }), [
            runtimeProps,
            unload
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUJtf.default), null, entryPointReference && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
            ...containerProps,
            entryPointReference: entryPointReference,
            errorFallback: errorFallback || 'flag',
            placeholderName: "modal-entry-point-container",
            runtimeProps: props
        }));
    };
});
parcelRegister("6KONZ", function(module, exports) {
    $parcel$export(module.exports, "servicedeskStandardToPremiumModalEntryPoint", ()=>$1e2c2973814b01a0$export$d21d0874477624e6);
    var $1ydNb = parcelRequire("1ydNb");
    var $6TOES = parcelRequire("6TOES");
    const $1e2c2973814b01a0$export$d21d0874477624e6 = (0, $6TOES.createEntryPoint)({
        root: (0, $1ydNb.JSResourceForInteraction)(()=>(parcelRequire("ap1ID")), {
            moduleId: "8d5c4464"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("ap1ID", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("9gafD")
    ]).then(()=>parcelRequire('dsKzv'));
});
parcelRegister("3w6SH", function(module, exports) {
    $parcel$export(module.exports, "useShouldPromptJsmTrial", ()=>$4dcc6671b7cd26e4$export$2503f783c1706b62);
    var $9CmwD = parcelRequire("9CmwD");
    var $eI5EY = parcelRequire("eI5EY");
    var $6WXNs = parcelRequire("6WXNs");
    var $ab6rA = parcelRequire("ab6rA");
    const $4dcc6671b7cd26e4$export$2503f783c1706b62 = ({ templateKey: templateKey })=>{
        const { serviceDesk: serviceDesk } = (0, $ab6rA.useAppEditions)();
        return {
            shouldPromptJsmTrial: serviceDesk !== (0, $6WXNs.PREMIUM_EDITION) && templateKey === (0, $9CmwD.IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY) && (0, $eI5EY.fg)('jsm_it_service_management_advanced_template')
        };
    };
});
parcelRegister("i0qR9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b3be4eeefa177d5$export$2e2bcd8739ae039);
    var $a9KyH = parcelRequire("a9KyH");
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $iWLL0 = parcelRequire("iWLL0");
    var $a6IG6 = parcelRequire("a6IG6");
    const $2b3be4eeefa177d5$export$f4619d70a16e5ea0 = ({ keyRef: keyRef })=>{
        const { iconUrl: iconUrl, iconDarkUrl: iconDarkUrl } = (0, $iWLL0.useFragment)((0, $a9KyH.default), keyRef);
        if (!iconUrl || !iconDarkUrl) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement($2b3be4eeefa177d5$var$IconImage, {
            alt: "",
            src: iconUrl,
            srcDark: iconDarkUrl
        });
    };
    const $2b3be4eeefa177d5$var$IconImage = (0, $eUqFw.forwardRef)(({ as: C = (0, $a6IG6.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1bsb1ylp _4t3i1ylp _2rko1l7b",
                __cmplp.className
            ])
        });
    });
    var $2b3be4eeefa177d5$export$2e2bcd8739ae039 = $2b3be4eeefa177d5$export$f4619d70a16e5ea0;
});
parcelRegister("a9KyH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01a1fccc11aee1ae$export$2e2bcd8739ae039);
    const $01a1fccc11aee1ae$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "icon_growthRecommendationsInProjectList_CardIcon",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            {
                "kind": "ScalarField",
                "name": "iconDarkUrl"
            }
        ],
        "type": "JiraProjectListViewTemplateItem"
    };
    $01a1fccc11aee1ae$var$node.hash = "7e2f6da3f7159903d326f431a5c01c87";
    var $01a1fccc11aee1ae$export$2e2bcd8739ae039 = $01a1fccc11aee1ae$var$node;
});
parcelRegister("7zLQ9", function(module, exports) {
    $parcel$export(module.exports, "buildCrossflowExtensions", ()=>$096c0053daf4eb01$export$11382497cf741299);
    var $eNw1f = parcelRequire("eNw1f");
    const $096c0053daf4eb01$export$11382497cf741299 = (args)=>{
        const { templateId: templateId, recommendationSessionId: recommendationSessionId } = args;
        const provisioningExtensions = (0, $eNw1f.createProvisioningPageExtensions)({
            actions: {
                primary: {
                    behaviour: (0, $eNw1f.Behaviours).LAND,
                    prompt: (0, $eNw1f.Prompts).NEXT,
                    options: {
                        targetTab: (0, $eNw1f.TargetTabs).SAME,
                        urlParams: {
                            templateId: templateId
                        }
                    }
                }
            }
        });
        const recoExtensions = (0, $eNw1f.createRecommendationContextExtensions)({
            recommendationSessionId: recommendationSessionId,
            entityId: templateId
        });
        const mergedExtensions = {};
        Object.assign(mergedExtensions, provisioningExtensions, recoExtensions);
        return mergedExtensions;
    };
});
parcelRegister("fvI0s", function(module, exports) {
    $parcel$export(module.exports, "TemplatePreview", ()=>$8461e7a23f61e511$export$48a171bbad47b95a);
    var $kx9aw = parcelRequire("kx9aw");
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $iWLL0 = parcelRequire("iWLL0");
    var $a6IG6 = parcelRequire("a6IG6");
    var $jGR8u = parcelRequire("jGR8u");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    var $eI5EY = parcelRequire("eI5EY");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $fvFzs = parcelRequire("fvFzs");
    const $8461e7a23f61e511$export$48a171bbad47b95a = ({ previewRef: previewRef })=>{
        const left = document.getElementById('ak-main-content')?.getBoundingClientRect().left ?? 0;
        const TemplatePreviewWrapperStyles = (0, $fHiYa.xcss)({
            width: `calc(100vw - ${(0, $fvFzs.SIDEBAR_WIDTH)}px - ${left}px)`,
            height: `calc(100vh - ${(0, $hwyJ1.UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT)} - ${(0, $hwyJ1.UNSAFE_DO_NOT_USE_BANNER_HEIGHT)})`,
            backgroundColor: 'elevation.surface',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'none',
            ':empty': {
                display: 'none'
            }
        });
        const TemplatePreviewAbsolutePositioning = (0, $fHiYa.xcss)({
            position: 'absolute',
            top: 'space.0',
            right: `${(0, $fvFzs.SIDEBAR_WIDTH)}px`,
            zIndex: 'spotlight',
            overflow: 'hidden'
        });
        const { title: title, description: description, key: key, previewUrl: previewUrl, previewDarkUrl: previewDarkUrl } = (0, $iWLL0.useFragment)((0, $kx9aw.default), previewRef);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: [
                TemplatePreviewWrapperStyles,
                !(0, $eI5EY.fg)('templates_sidebar_preview_in_popup') && TemplatePreviewAbsolutePositioning
            ]
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($8461e7a23f61e511$var$TemplateAreaContainer, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            xcss: $8461e7a23f61e511$var$PreviewWrapperStyles,
            space: "space.500"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            xcss: $8461e7a23f61e511$var$TextContainerStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            as: "span",
            xcss: $8461e7a23f61e511$var$TitleStyles
        }, title), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            as: "p",
            xcss: $8461e7a23f61e511$var$DescriptionStyles
        }, description)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            as: "span",
            xcss: $8461e7a23f61e511$var$ImageWrapperStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($8461e7a23f61e511$var$PreviewImage, {
            src: previewUrl,
            key: key,
            alt: "",
            srcDark: previewDarkUrl
        })))));
    };
    const $8461e7a23f61e511$var$TemplateAreaContainer = (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1bsb12it _1tku1ssb",
                __cmplp.className
            ])
        });
    });
    const $8461e7a23f61e511$var$ImageWrapperStyles = (0, $fHiYa.xcss)({
        aspectRatio: '100/62'
    });
    const $8461e7a23f61e511$var$TextContainerStyles = (0, $fHiYa.xcss)({
        color: 'color.text'
    });
    const $8461e7a23f61e511$var$TitleStyles = (0, $fHiYa.xcss)({
        font: "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    });
    const $8461e7a23f61e511$var$DescriptionStyles = (0, $fHiYa.xcss)({
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        margin: '0'
    });
    const $8461e7a23f61e511$var$PreviewWrapperStyles = (0, $fHiYa.xcss)({
        backgroundColor: 'elevation.surface'
    });
    const $8461e7a23f61e511$var$PreviewImage = (0, $eUqFw.forwardRef)(({ as: C = (0, $a6IG6.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_5ral1f51 _rsufjp4b _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kx9aw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9f7c12440d55870$export$2e2bcd8739ae039);
    const $a9f7c12440d55870$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "preview_growthRecommendationsInProjectList_TemplatePreview",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "title"
                },
                "action": "THROW",
                "path": "title"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "description"
                },
                "action": "THROW",
                "path": "description"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "key"
                },
                "action": "THROW",
                "path": "key"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "previewUrl"
                },
                "action": "THROW",
                "path": "previewUrl"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "previewDarkUrl"
                },
                "action": "THROW",
                "path": "previewDarkUrl"
            }
        ],
        "type": "JiraProjectListViewTemplateItem"
    };
    $a9f7c12440d55870$var$node.hash = "f298dd557d1046875fbc288cf964ef36";
    var $a9f7c12440d55870$export$2e2bcd8739ae039 = $a9f7c12440d55870$var$node;
});
parcelRegister("3TS41", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectListSidePanelSkipLink", ()=>$adbdc3286e302113$export$32072395400d2f38);
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $fdWUr = parcelRequire("fdWUr");
    const $adbdc3286e302113$export$32072395400d2f38 = ()=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        (0, $hwyJ1.useCustomSkipLink)('jira-project-list-side-panel', formatMessage((0, $fdWUr.default).skipToRightSidePanel), 4);
        return null;
    };
});
parcelRegister("fdWUr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$815f88fd4fde21ea$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $815f88fd4fde21ea$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        skipToRightSidePanel: {
            "id": "growth-recommendations-in-project-list.skip-link.skip-to-right-side-panel",
            "defaultMessage": "Skip to Side Panel"
        }
    });
});
